export const TvLivestreamNowAndNextApiPath = '/tv-livestreams-now-and-next';
export const tvLivestreamNowAndNextIntervalInSeconds = 300;
export const loadTvLivestreamsNowAndNext = async axios => {
  const requestUrl = `${TvLivestreamNowAndNextApiPath}`;
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};